import { ClientOutput } from './client-output.interface';

export class BpasClientOutput extends ClientOutput {

	constructor(public suite = '', public clientName = '', public audience = '') {
		super(null, null, null, null);
	}
}
